/**
 * Filter count display component
 *
 * @param {number} filtered - Number of filtered items
 * @param {number} total - Total number of items
 * @param {string} label - Item label (e.g., "projects", "names")
 * @param {string} className - Additional classes
 */
const FilterCount = ({
  filtered,
  total,
  label = "items",
  className = "",
}) => {
  const text = filtered === total
    ? `${total} ${label}`
    : `${filtered} of ${total} ${label}`;

  return (
    <span className={`text-xs text-base-content/40 ${className}`}>
      {text}
    </span>
  );
};

export default FilterCount;
